import { withLazyErrorBoundary } from '@office-start/office-home-app-shared';
import React, { lazy } from 'react';
import { useShouldShowNewUserShelf } from './hooks/useShouldShowNewUserShelf';
var NewUserShelf = withLazyErrorBoundary(lazy(function () { return import(/*webpackChunkName: "nus" */ './NewUserShelf'); }), 'NewUserShelf');
export var NewUserShelfLazy = function () {
    var _a = useShouldShowNewUserShelf(), shouldShowNewUserShelf = _a.shouldShowNewUserShelf, state = _a.state;
    return shouldShowNewUserShelf ? React.createElement(NewUserShelf, { state: state }) : null;
};
//# sourceMappingURL=NewUserShelfLazy.js.map